import { readOrganization } from '@usehatchapp/javascript-sdk';
import camelcaseKeys from 'camelcase-keys';
import { SET_FRESH_ORGANIZATION_KEY } from 'root/stores/fresh';
import { ORGANIZATION_DETAILS } from 'root/stores/fresh/schema';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';
import validateSchema from 'utils/validateSchema';

import { constants } from '../constants';
import { organizationSchema } from '../schema';

export const doReadOrganization =
  ({ organizationIDs = [] } = {}) =>
  async ({ dispatch, request }) => {
    const {
      READ_ORGANIZATION_FAILURE,
      READ_ORGANIZATION_REQUEST,
      READ_ORGANIZATION_SUCCESS,
    } = constants;

    try {
      // if not an array or the ID format is incorrect, bail
      if (
        !Array.isArray(organizationIDs) ||
        !organizationIDs.length ||
        !organizationIDs.every(isCorrectHatchIdFormat)
      )
        throw new Error('Invalid organizationId format');

      // tell state we're fetching organization
      dispatch({ type: READ_ORGANIZATION_REQUEST });

      const validatedOrganizations = [];

      const organizations = await Promise.all(
        // Map the ids into an iterator of promises for the `all` method
        organizationIDs.map((organizationId) => {
          return request(readOrganization, {
            organizationId,
          });
        }),
      ).catch((error) => {
        dispatch({ error, type: READ_ORGANIZATION_FAILURE });
      });

      organizations.forEach((organizationResponse) => {
        // validate organization
        const validatedOrganization = validateSchema({
          payload: camelcaseKeys(organizationResponse),
          schema: organizationSchema,
        });

        // push it to array
        validatedOrganizations.push(validatedOrganization);
      });

      // load twilio registrations for each organization
      dispatch({
        actionCreator: 'doReadOrganizationTwilioRegistrations',
        args: [{ organizationIDs }],
      });

      // reduce organization payload into store
      dispatch({
        actions: [
          {
            payload: { organizations: validatedOrganizations },
            type: READ_ORGANIZATION_SUCCESS,
          },
          {
            payload: {
              fresh: true,
              key: ORGANIZATION_DETAILS,
              organizationIDs,
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
    } catch (error) {
      dispatch({ error, type: READ_ORGANIZATION_FAILURE });
    }
  };
